import { Theme } from 'lib/ui'
import { heading1, heading2, heading3, buttonPrimary, container, containerWide, link } from './css'

export const livBriteTheme: Theme = {
  maxWidth: '1635px',
  palette: {
    primary: {
      alphaDark: '#345D7F',
      alpha: '#71ACB7',
      alphaLight: '#c6dee2',
      beta: '#90C73E',
      gamma: '#A0D8E5'
    },
    general: {
      dark: '#000',
      light: '#FFF',
      strong: '#162735',
      strongMutted: '#5c6872',
      greyDark: '#707070',
      greyMed: '#949494',
      grey: '#B7B7B7',
      greyLight: '#DBDBDB',
      greyLighter: '#e5e5e5',
      greyExtraLight: '#f5f5f5',
      greyMutted: '#c3bebb',
      blueDark: '#3B5998',
      alphaMutted: '#BFD7D9',
      soft: '#F0F0F0',
      boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
      lightOpacity: 'rgba(255,255,255,0.85)',
      darkOpacity: 'rgba(0, 48, 88, 0.65)',
      lightGradient: 'linear-gradient(180deg, #F7F7F7 0%, #FFFFFF 50.04%, #F7F7F7 100%)'
    },
    state: {
      success: '#789C4A',
      successLighter: '#defff0',
      danger: '#96262C',
      dangerLighter: '#F9DFDE',
      info: '#495459',
      infoLighter: '#E2F6FD',
      alert: '#c89211',
      alertLighter: '#FDD377'
    }
  },
  form: {
    fontColor: '#3F3F3F',
    labelColor: '#345D7F',
    indicatorColor: '#A5A5A5',
    placeholderColor: '#BCBCBC',
    passiveColor: '#CDCCCF',
    inputBackgroundColor: '#FFF',
    inputDisabledBackgroundColor: '#EEE',
    innerBoxShadow: 'none',
    boxShadow: '0 0 7px rgba(0, 0, 0, 0.3)',
    borderRadius: '2px'
  },
  font: {
    default: {
      family: 'Avenir, Arial, sans-serif',
      light: '200',
      normal: '300',
      medium: '500',
      bold: '900'
    },
    alt: {
      family: '"Baskervald ADF Std Italic", serif',
      light: '300',
      normal: '400',
      medium: '500',
      bold: '700'
    }
  },
  productSelector: {
    darkBg: '#71ACB7',
    bgColor: '#A0D8E5',
    reviewBgColor: '#CFEBF2',
    reviewColorDark: '#A0D8E5',
    checkColor: '#849d67'
  },
  css: {
    heading1,
    heading2,
    heading3,
    buttonPrimary,
    container,
    containerWide,
    link
  }
}
